export const DhcpFields: EditorPropType[] = [
  // Connection Type [EDITABLE]
  {
    field: 'connectionType',
    type: 'text',
    notEditable: true,
    disabledFields: ['PPPOE', 'DHCP', 'STATIC', 'BRIDGE'],
  },

  // Service Type [EDITABLE]
  {
    field: 'serviceType',
    type: 'select',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: false,
    multiple: true,
    options: ['INTERNET', 'VOIP', 'TR069', 'IPTV', 'OTHERS'],
  },

  // MAC Address [NOT EDITABLE]
  {
    field: 'macAddress',
    type: 'text',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: true,
  },
  // Alias [NOT EDITABLE]
  {
    field: 'alias',
    type: 'text',
    disabledFields: [],
    notEditable: true,
  },

  // Enable [EDITABLE]
  {
    field: 'enable',
    type: 'boolean',
    disabledFields: [],
    notEditable: false,
  },

  // MTU
  {
    field: 'mtu',
    type: 'text',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: false,
  },

  // [WAN] VLAN Configuration
  {
    field: 'vlanEnable',
    type: 'boolean',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: false,
  },
  {
    field: 'vlan',
    type: 'text',
    disabledFields: ['vlanEnable', 'enable'],
    notEditable: false,
    notVisible: 'vlanEnable',
  },

  // IPv6
  {
    field: 'ipv6Enable',
    type: 'boolean',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: false,
  },
  {
    field: 'ipv6PrefixLength',
    type: 'text',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'ipv6Enable', value: false },
    ],
    notEditable: false,
    notVisible: 'ipv6Enable',
  },
  {
    field: 'ipv6AddressingType',
    type: 'select',
    options: ['Auto', 'SLAAC', 'DHCPv6'],
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'ipv6Enable', value: false },
    ],
    notEditable: false,
    notVisible: 'ipv6Enable',
  },

  //  [WAN] NAT
  {
    field: 'nat',
    type: 'boolean',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: false,
  },
  {
    field: 'natBoost',
    type: 'boolean',
    disabledFields: ['nat', 'enable'],
    notEditable: false,
    notVisible: 'nat',
  },
  {
    field: 'fullConeNat',
    type: 'boolean',
    disabledFields: ['nat', 'enable'],
    notEditable: false,
    notVisible: 'nat',
  },
];

export const PPPOEFields: EditorPropType[] = [
  // Connection Type [EDITABLE]
  {
    field: 'connectionType',
    type: 'text',
    notEditable: true,
    disabledFields: ['PPPOE', 'DHCP', 'STATIC', 'BRIDGE'],
  },

  // Service Type [EDITABLE]
  {
    field: 'serviceType',
    type: 'select',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: false,
    multiple: true,
    options: ['INTERNET', 'VOIP', 'TR069', 'IPTV', 'OTHERS'],
  },

  // MAC Address [NOT EDITABLE]
  {
    field: 'macAddress',
    type: 'text',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: true,
  },
  // Alias [NOT EDITABLE]
  {
    field: 'alias',
    type: 'text',
    disabledFields: [],
    notEditable: true,
  },

  // Enable [EDITABLE]
  {
    field: 'enable',
    type: 'boolean',
    disabledFields: [],
    notEditable: false,
  },

  // MTU
  {
    field: 'mtu',
    type: 'text',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: false,
  },
  {
    field: 'userPPPoE',
    type: 'text',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'STATIC' },
    ],
    notEditable: false,
  },
  {
    field: 'passwordPPPoE',
    type: 'text',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'STATIC' },
    ],
    notEditable: false,
  },
  {
    field: 'connectionMode',
    type: 'select',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'STATIC' },
    ],
    options: ['AUTO', 'MANUAL', 'ON DEMAND'],
    notEditable: false,
  },
  {
    field: 'authenticationType',
    type: 'select',
    disabledFields: [{ field: 'enable', value: false }],
    options: ['AUTO', 'PAP', 'CHAP', 'MS_CHAP'],
    notEditable: false,
  },
  // [WAN] VLAN Configuration
  {
    field: 'vlanEnable',
    type: 'boolean',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: false,
  },
  {
    field: 'vlan',
    type: 'text',
    disabledFields: ['vlanEnable', 'enable'],
    notEditable: false,
    notVisible: 'vlanEnable',
  },

  // IPv6
  {
    field: 'ipv6Enable',
    type: 'boolean',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: false,
  },
  {
    field: 'ipv6PrefixLength',
    type: 'text',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'ipv6Enable', value: false },
    ],
    notEditable: false,
    notVisible: 'ipv6Enable',
  },
  {
    field: 'ipv6AddressingType',
    type: 'select',
    options: ['Auto', 'SLAAC', 'DHCPv6'],
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'ipv6Enable', value: false },
    ],
    notEditable: false,
    notVisible: 'ipv6Enable',
  },

  //  [WAN] NAT
  {
    field: 'nat',
    type: 'boolean',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: false,
  },
  {
    field: 'natBoost',
    type: 'boolean',
    disabledFields: ['nat', 'enable'],
    notEditable: false,
    notVisible: 'nat',
  },
  {
    field: 'fullConeNat',
    type: 'boolean',
    disabledFields: ['nat', 'enable'],
    notEditable: false,
    notVisible: 'nat',
  },
];

export const StaticFields: EditorPropType[] = [
  // Connection Type [EDITABLE]
  {
    field: 'connectionType',
    type: 'text',
    notEditable: true,
    disabledFields: ['PPPOE', 'DHCP', 'STATIC', 'BRIDGE'],
  },

  // Service Type [EDITABLE]
  {
    field: 'serviceType',
    type: 'select',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: false,
    multiple: true,
    options: ['INTERNET', 'VOIP', 'TR069', 'IPTV', 'OTHERS'],
  },

  // MAC Address [NOT EDITABLE]
  {
    field: 'macAddress',
    type: 'text',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: true,
  },
  // Alias [NOT EDITABLE]
  {
    field: 'alias',
    type: 'text',
    disabledFields: [],
    notEditable: true,
  },

  // Enable [EDITABLE]
  {
    field: 'enable',
    type: 'boolean',
    disabledFields: [],
    notEditable: false,
  },

  // MTU
  {
    field: 'mtu',
    type: 'text',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: false,
  },

  // IPv4 Enable [EDITABLE]
  {
    field: 'ipv4Enable',
    type: 'boolean',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
  },

  // IPv4 [EDITABLE]
  {
    field: 'ipv4',
    type: 'text',
    disabledFields: [
      { field: 'ipv4Enable', value: false },
      { field: 'enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
    notVisible: 'ipv4Enable',
  },
  {
    field: 'mask',
    type: 'text',
    disabledFields: [
      { field: 'ipv4Enable', value: false },
      { field: 'enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
    notVisible: 'ipv4Enable',
  },
  {
    field: 'ipv4Gateway',
    type: 'text',
    disabledFields: [
      { field: 'ipv4Enable', value: false },
      { field: 'enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
    notVisible: 'ipv4Enable',
  },
  {
    field: 'ipv4Dns',
    type: 'text',
    disabledFields: [
      { field: 'ipv4Enable', value: false },
      { field: 'enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
    notVisible: 'ipv4Enable',
  },

  // [WAN] Global Rule IPv6 and Settings
  {
    field: 'ipv6Enable',
    type: 'boolean',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
  },

  {
    field: 'ipv6',
    type: 'text',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'ipv6Enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
    notVisible: 'ipv6Enable',
  },
  {
    field: 'ipv6PrefixLength',
    type: 'text',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'ipv6Enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
    notVisible: 'ipv6Enable',
  },
  {
    field: 'ipv6Gateway',
    type: 'text',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'ipv6Enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
    notVisible: 'ipv6Enable',
  },
  {
    field: 'ipv6Dns',
    type: 'text',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'ipv6Enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
    notVisible: 'ipv6Enable',
  },

  // [WAN] VLAN Configuration
  {
    field: 'vlanEnable',
    type: 'boolean',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: false,
  },
  {
    field: 'vlan',
    type: 'text',
    disabledFields: ['vlanEnable', 'enable'],
    notEditable: false,
    notVisible: 'vlanEnable',
  },

  //  [WAN] NAT
  {
    field: 'nat',
    type: 'boolean',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: false,
  },
  {
    field: 'natBoost',
    type: 'boolean',
    disabledFields: ['nat', 'enable'],
    notEditable: false,
    notVisible: 'nat',
  },
  {
    field: 'fullConeNat',
    type: 'boolean',
    disabledFields: ['nat', 'enable'],
    notEditable: false,
    notVisible: 'nat',
  },
];

export const BridgeFields: EditorPropType[] = [
  // Connection Type [EDITABLE]
  {
    field: 'connectionType',
    type: 'text',
    notEditable: true,
    disabledFields: ['PPPOE', 'DHCP', 'STATIC', 'BRIDGE'],
  },

  // Service Type [EDITABLE]
  {
    field: 'serviceType',
    type: 'select',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: false,
    options: ['INTERNET', 'VOIP', 'TR069', 'IPTV', 'OTHERS'],
  },

  // MAC Address [NOT EDITABLE]
  {
    field: 'macAddress',
    type: 'text',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: true,
  },
  // Alias [NOT EDITABLE]
  {
    field: 'alias',
    type: 'text',
    disabledFields: [],
    notEditable: true,
  },

  // Enable [EDITABLE]
  {
    field: 'enable',
    type: 'boolean',
    disabledFields: [],
    notEditable: false,
  },

  // MTU
  {
    field: 'mtu',
    type: 'text',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: false,
  },

  // IPv4 Enable [EDITABLE]
  {
    field: 'ipv4Enable',
    type: 'boolean',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
  },

  // IPv4 [EDITABLE]
  {
    field: 'ipv4',
    type: 'text',
    disabledFields: [
      { field: 'ipv4Enable', value: false },
      { field: 'enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
    notVisible: 'ipv4Enable',
  },
  {
    field: 'mask',
    type: 'text',
    disabledFields: [
      { field: 'ipv4Enable', value: false },
      { field: 'enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
    notVisible: 'ipv4Enable',
  },
  {
    field: 'ipv4Gateway',
    type: 'text',
    disabledFields: [
      { field: 'ipv4Enable', value: false },
      { field: 'enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
    notVisible: 'ipv4Enable',
  },
  {
    field: 'ipv4Dns',
    type: 'text',
    disabledFields: [
      { field: 'ipv4Enable', value: false },
      { field: 'enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
    notVisible: 'ipv4Enable',
  },

  // [WAN] Global Rule IPv6 and Settings
  {
    field: 'ipv6Enable',
    type: 'boolean',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
  },

  {
    field: 'ipv6',
    type: 'text',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'ipv6Enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
    notVisible: 'ipv6Enable',
  },
  {
    field: 'ipv6PrefixLength',
    type: 'text',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'ipv6Enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
    notVisible: 'ipv6Enable',
  },
  {
    field: 'ipv6Gateway',
    type: 'text',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'ipv6Enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
    notVisible: 'ipv6Enable',
  },
  {
    field: 'ipv6AddressingType',
    type: 'select',
    options: ['Auto', 'SLAAC', 'DHCPv6'],
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'ipv6Enable', value: false },
      { field: 'connectionType', value: 'STATIC' },
    ],
    notEditable: false,
    notVisible: 'ipv6Enable',
  },
  {
    field: 'ipv6Dns',
    type: 'text',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'ipv6Enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
    notVisible: 'ipv6Enable',
  },

  // [WAN] VLAN Configuration
  {
    field: 'vlanEnable',
    type: 'boolean',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: false,
  },
  {
    field: 'vlan',
    type: 'text',
    disabledFields: ['vlanEnable', 'enable'],
    notEditable: false,
    notVisible: 'vlanEnable',
  },

  //  [WAN] NAT
  {
    field: 'nat',
    type: 'boolean',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: false,
  },
  {
    field: 'natBoost',
    type: 'boolean',
    disabledFields: ['nat', 'enable'],
    notEditable: false,
    notVisible: 'nat',
  },
  {
    field: 'fullConeNat',
    type: 'boolean',
    disabledFields: ['nat', 'enable'],
    notEditable: false,
    notVisible: 'nat',
  },
];

export const lanFields: EditorPropType[] = [
  {
    field: 'ipAddress',
    type: 'text',
    disabledFields: [],
    notEditable: false,
  },
  { field: 'gateway', type: 'text', disabledFields: [], notEditable: false },
  { field: 'mask', type: 'text', disabledFields: [], notEditable: false },
  {
    field: 'dnsServers',
    type: 'text',
    disabledFields: [],
    notEditable: false,
  },
  {
    field: 'dhcpEnable',
    type: 'boolean',
    disabledFields: [],
    notEditable: false,
  },
  {
    field: 'dhcpMin',
    type: 'text',
    disabledFields: [{ field: 'dhcpEnable', value: false }],
    notEditable: false,
  },
  {
    field: 'dhcpMax',
    type: 'text',
    disabledFields: [{ field: 'dhcpEnable', value: false }],
    notEditable: false,
  },
  {
    field: 'leasing',
    type: 'text',
    disabledFields: [{ field: 'dhcpEnable', value: false }],
    notEditable: false,
  },
];

export const wifiFields: EditorPropType[] = [
  {
    field: 'frequency',
    type: 'text',
    notEditable: false,
    disabledFields: [],
  },
  {
    field: 'ssid',
    type: 'text',
    notEditable: false,
    disabledFields: [],
  },
  {
    field: 'password',
    type: 'text',
    notEditable: false,
    disabledFields: [],
  },
  {
    field: 'encryption',
    type: 'select',
    notEditable: false,
    disabledFields: [],
    options: ['AES', 'TKIP', 'AES/TKIP'],
  },
  {
    field: 'authentication',
    type: 'select',
    notEditable: false,
    disabledFields: [],
    options: [
      'NONE',
      'WPA-PERSONAL',
      'WPA2-PERSONAL',
      'WPA3-PERSONAL',
      'WPA/WPA2 PERSONAL',
      'WPA2/WPA3 PERSONAL',
    ],
  },
  {
    field: 'macAddress',
    type: 'text',
    notEditable: true,
    disabledFields: [],
  },
  {
    field: 'ssidEnable',
    type: 'boolean',
    notEditable: false,
    disabledFields: [],
  },
  {
    field: 'apEnable',
    type: 'boolean',
    notEditable: false,
    disabledFields: [],
  },
  {
    field: 'visible',
    type: 'boolean',
    notEditable: false,
    disabledFields: [],
  },
  {
    field: 'maxHosts',
    type: 'text',
    notEditable: false,
    disabledFields: [],
  },
];

export const genericWanFields: EditorPropType[] = [
  {
    field: 'bytesSent',
    type: 'text',
    notEditable: true,
    disabledFields: [],
  },
  {
    field: 'bytesReceived',
    type: 'text',
    notEditable: true,
    disabledFields: ['enable'],
  },
  {
    field: 'packetsSent',
    type: 'text',
    notEditable: true,
    disabledFields: [],
  },
  {
    field: 'packetsReceived',
    type: 'text',
    notEditable: true,
    disabledFields: [],
  },
  {
    field: 'errorsSent',
    type: 'text',
    notEditable: true,
    disabledFields: [],
  },
  {
    field: 'errorsReceived',
    type: 'text',
    notEditable: true,
    disabledFields: [],
  },
  {
    field: 'discardPacketsSent',
    type: 'text',
    notEditable: true,
    disabledFields: [],
  },
  {
    field: 'discardPacketsReceived',
    type: 'text',
    notEditable: true,
    disabledFields: [],
  },
];

export const radio24FieldList: EditorPropType[] = [
  {
    field: 'frequency',
    type: 'text',
    notEditable: true,
    disabledFields: [],
  },
  {
    field: 'enable',
    type: 'boolean',
    notEditable: false,
    disabledFields: [],
  },
  {
    field: 'status',
    type: 'text',
    notEditable: false,
    disabledFields: [{ field: 'enable', value: false }],
  },
  {
    field: 'bandWidthCurrent',
    type: 'text',
    notEditable: true,
    disabledFields: [{ field: 'enable', value: false }],
  },
  {
    field: 'bandWidthOperation',
    type: 'select',
    notEditable: false,
    options: ['20MHZ', '40MHZ', 'AUTO'],
    disabledFields: [{ field: 'enable', value: false }],
  },
  // channelsPossible
  {
    field: 'channelAuto',
    type: 'boolean',
    notEditable: false,
    disabledFields: [{ field: 'enable', value: false }],
  },
  {
    field: 'channel',
    type: 'select',
    options: ['1', '2', '3', '4', '5', '6', '7', '8', '90', '10', '11'],
    notEditable: false,
    disabledFields: [
      { field: 'channelAuto', value: true },
      { field: 'enable', value: false },
    ],
  },
  {
    field: 'channelsInUse',
    type: 'text',
    notEditable: false,
    disabledFields: [{ field: 'enable', value: false }],
  },
  {
    field: 'transmitPower',
    type: 'select',
    options: ['25', '50', '177'],
    notEditable: false,
    disabledFields: [{ field: 'enable', value: false }],
  },
];

export const radio50FieldList: EditorPropType[] = [
  {
    field: 'frequency',
    type: 'text',
    notEditable: true,
    disabledFields: [],
  },
  {
    field: 'enable',
    type: 'boolean',
    notEditable: false,
    disabledFields: [],
  },
  {
    field: 'status',
    type: 'text',
    notEditable: false,
    disabledFields: [{ field: 'enable', value: false }],
  },
  {
    field: 'bandWidthCurrent',
    type: 'text',
    notEditable: true,
    disabledFields: [{ field: 'enable', value: false }],
  },
  {
    field: 'bandWidthOperation',
    type: 'select',
    notEditable: false,
    options: ['Auto', '20MHz', '40MHz', '80MHz', '160MHz'],
    disabledFields: [{ field: 'enable', value: false }],
  },
  // channelsPossible
  {
    field: 'channelAuto',
    type: 'boolean',
    notEditable: false,
    disabledFields: [{ field: 'enable', value: false }],
  },
  {
    field: 'channel',
    type: 'select',
    options: [
      '36',
      '40',
      '44',
      '48',
      '52',
      '56',
      '60',
      '64',
      '100',
      '104',
      '108',
      '112',
      '116',
      '120',
      '124',
      '128',
      '132',
      '136',
      '140',
      '144',
      '149',
      '153',
      '157',
      '161',
      '165',
    ],
    notEditable: false,
    disabledFields: [
      { field: 'channelAuto', value: true },
      { field: 'enable', value: false },
    ],
  },
  {
    field: 'channelsInUse',
    type: 'text',
    notEditable: false,
    disabledFields: [{ field: 'enable', value: false }],
  },
  {
    field: 'transmitPower',
    type: 'select',
    options: ['25', '77', '100'],
    notEditable: false,
    disabledFields: [{ field: 'enable', value: false }],
  },
];

export const wanFields: EditorPropType[] = [
  // [WAN] Connection Identifiers ---
  {
    field: 'connectionType',
    type: 'text',
    notEditable: true,
    disabledFields: [],
  },
  {
    field: 'serviceType',
    type: 'select',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: false,
    options: ['internet_tr069', 'internet', 'voip', 'iptv'],
  },
  {
    field: 'macAddress',
    type: 'text',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: true,
  },
  {
    field: 'alias',
    type: 'text',
    disabledFields: [],
    notEditable: true,
  },
  {
    field: 'status',
    type: 'text',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: true,
  },

  // [WAN] General Configuration
  {
    field: 'enable',
    type: 'boolean',
    disabledFields: [],
    notEditable: false,
  },
  {
    field: 'mtu',
    type: 'text',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: false,
  },

  // [WAN] Global Rule IPv4 and Settings
  {
    field: 'ipv4Enable',
    type: 'boolean',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
  },
  {
    field: 'ipv4',
    type: 'text',
    disabledFields: [
      { field: 'ipv4Enable', value: false },
      { field: 'enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
  },
  {
    field: 'mask',
    type: 'text',
    disabledFields: [
      { field: 'ipv4Enable', value: false },
      { field: 'enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
  },
  {
    field: 'ipv4Gateway',
    type: 'text',
    disabledFields: [
      { field: 'ipv4Enable', value: false },
      { field: 'enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
  },
  {
    field: 'ipv4Dns',
    type: 'text',
    disabledFields: [
      { field: 'ipv4Enable', value: false },
      { field: 'enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
  },
  // [WAN] Global Rule IPv6 and Settings
  {
    field: 'ipv6Enable',
    type: 'boolean',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
  },
  {
    field: 'ipv6',
    type: 'text',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'ipv6Enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
    notVisible: 'ipv6Enable',
  },
  {
    field: 'ipv6PrefixLength',
    type: 'text',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'ipv6Enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
    notVisible: 'ipv6Enable',
  },
  {
    field: 'ipv6Gateway',
    type: 'text',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'ipv6Enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
    notVisible: 'ipv6Enable',
  },
  {
    field: 'ipv6AddressingType',
    type: 'select',
    options: ['Auto', 'SLAAC', 'DHCPv6'],
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'ipv6Enable', value: false },
      { field: 'connectionType', value: 'STATIC' },
    ],
    notEditable: false,
    notVisible: 'ipv6Enable',
  },
  {
    field: 'ipv6Dns',
    type: 'text',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'ipv6Enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'PPPOE' },
    ],
    notEditable: false,
    notVisible: 'ipv6Enable',
  },

  // [WAN] VLAN Configuration
  {
    field: 'vlanEnable',
    type: 'boolean',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: false,
  },
  {
    field: 'vlan',
    type: 'text',
    disabledFields: ['vlanEnable', 'enable'],
    notEditable: false,
  },

  //  [WAN] NAT
  {
    field: 'nat',
    type: 'boolean',
    disabledFields: [{ field: 'enable', value: false }],
    notEditable: false,
  },
  {
    field: 'natBoost',
    type: 'boolean',
    disabledFields: ['nat', 'enable'],
    notEditable: false,
  },
  {
    field: 'fullConeNat',
    type: 'boolean',
    disabledFields: ['nat', 'enable'],
    notEditable: false,
  },

  // [WAN] PPPOE Configuration
  {
    field: 'userPPPoE',
    type: 'text',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'STATIC' },
    ],
    notEditable: false,
  },
  {
    field: 'passwordPPPoE',
    type: 'text',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'STATIC' },
    ],
    notEditable: false,
  },
  {
    field: 'connectionMode',
    type: 'select',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'STATIC' },
    ],
    options: ['Manual', 'Automático', 'Sob demanda'],
    notEditable: false,
  },
  {
    field: 'authenticationType',
    type: 'select',
    disabledFields: [
      { field: 'enable', value: false },
      { field: 'connectionType', value: 'DHCP' },
      { field: 'connectionType', value: 'STATIC' },
    ],
    options: ['AUTO', 'PAP', 'CHAP', 'MS_CHAP'],
    notEditable: false,
  },
];

export const managementFields: EditorPropType[] = [
  {
    field: 'serverUrl',
    type: 'text',
    notEditable: false,
    disabledFields: [],
  },
  {
    field: 'serverUser',
    type: 'text',
    notEditable: false,
    disabledFields: [],
  },
  {
    field: 'serverPassword',
    type: 'text',
    notEditable: false,
    disabledFields: [],
  },
  {
    field: 'periodicEnable',
    type: 'boolean',
    notEditable: false,
    disabledFields: [],
  },
  {
    field: 'periodicInterval',
    type: 'text',
    notEditable: false,
    disabledFields: [{ field: 'periodicEnable', value: false }],
  },
  {
    field: 'cpeUser',
    type: 'text',
    notEditable: false,
    disabledFields: [],
  },
  {
    field: 'cpePassword',
    type: 'text',
    notEditable: false,
    disabledFields: [],
  },
];

export const voipFields: EditorPropType[] = [
  {
    field: 'enable',
    type: 'boolean',
    notEditable: false,
    disabledFields: [],
  },
  {
    field: 'status',
    type: 'text',
    notEditable: true,
    disabledFields: [],
  },
  {
    field: 'user',
    type: 'text',
    notEditable: false,
    disabledFields: [],
  },
  {
    field: 'password',
    type: 'text',
    notEditable: false,
    disabledFields: [],
  },
  {
    field: 'proxy',
    type: 'text',
    notEditable: false,
    disabledFields: [],
  },
  {
    field: 'proxyPort',
    type: 'text',
    notEditable: false,
    disabledFields: [],
  },
  {
    field: 'serverProxy',
    type: 'text',
    notEditable: false,
    disabledFields: [],
  },
  {
    field: 'serverProxyPort',
    type: 'text',
    notEditable: false,
    disabledFields: [],
  },
  {
    field: 'registryServer',
    type: 'text',
    notEditable: false,
    disabledFields: [],
  },
  {
    field: 'registryServerPort',
    type: 'text',
    notEditable: false,
    disabledFields: [],
  },
];

export const webUserFields: EditorPropType[] = [
  {
    field: 'enable',
    type: 'boolean',
    notEditable: false,
    disabledFields: [],
  },
  {
    field: 'username',
    type: 'text',
    notEditable: false,
    disabledFields: [{ field: 'enable', value: false }],
  },
  {
    field: 'password',
    type: 'text',
    notEditable: false,
    disabledFields: [{ field: 'enable', value: false }],
  },
];

export const SPECTRUM_COLORS = [
  '#00CFFF',
  '#FF4C8B',
  '#4DFF91',
  '#FFD300',
  '#B44DFF',
  '#FF8C4D',
  '#4D8CFF',
  '#FF6B6B',
  '#00FF9F',
  '#FF9F00',
];
